import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-math-function-icon',
  templateUrl: './math-function.component.html'
})
export class MathFunctionComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
